export const colors = {
  grey: '#7E7E7E',
  greyV2: '#F1F1F1',
  bg: '#FBFBFB',
  bgV2: '#F2F2F2',
  separator: '#e7e7e7',
  greyedText: '#636363',
}
